<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2ded"><a id="page_3">Dedication</a></h2><a id="page_3">
</a><p class="ded"><a id="page_3">To my intuitive, creative Pisces sister, Patti, with love.</a><a id="page_4"></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?97cc4776